/**
 * Which edition this console is talking to, read from the discovery document at start
 * (`edition: "cloud"` for Mojo Up AI Cloud; absent or `enterprise` for self-hosted AIOE). One image
 * serves both: the edition is fixed for the page's lifetime, so views read it at render.
 */

import type { Edition } from '@aioe/shared';

let edition: Edition = 'enterprise';

/** The product's name in each edition: the SaaS is branded Mojo Up AI Cloud; self-hosted keeps the Enterprise name. */
const PRODUCT: Record<Edition, { name: string; short: string; byline: string }> = {
  enterprise: { name: 'AI Enterprise Operating Environment', short: 'AI Enterprise OE', byline: '' },
  cloud: { name: 'Mojo Up AI Cloud', short: 'Mojo Up AI Cloud', byline: 'by Mojo Up' },
};

export function setEdition(next: Edition | undefined): void {
  edition = next ?? 'enterprise';
  if (typeof document !== 'undefined') document.title = PRODUCT[edition].name;
}

/** What this console is called, for the brand block and the window title. */
export const productName = (): string => PRODUCT[edition].name;
export const productShortName = (): string => PRODUCT[edition].short;
/** The second line under the brand: the organisation on Enterprise, the maker on Cloud (whose organisation is the product). */
export const productByline = (organisation: string | undefined): string => (edition === 'cloud' ? PRODUCT.cloud.byline : (organisation ?? ''));

/** Mojo Up AI Cloud: its own sign-in, many organisations, and no mesh, portfolio, budgets or Graph. */
export const isCloud = (): boolean => edition === 'cloud';
